import { Component, Input } from '@angular/core';
import { InnerRoute } from '../containers/inner-header/inner-header.component';
import { animate, query, stagger, style, transition, trigger } from '@angular/animations';

const breadcrumbsAnimation = trigger('breadcrumbsAnimation', [
  transition(':enter', [
    query(
      ':enter',
      [
        style({ opacity: 0, transform: 'translateY(40px) rotateX(90deg)' }),
        stagger(
          '50ms',
          animate(
            '600ms cubic-bezier(0,.81,.18,1)',
            style({ opacity: 1, transform: 'translateY(0px) rotateX(0deg)' })
          )
        ),
      ],
      { optional: true }
    ),
  ]),
]);

@Component({
  selector: 'survey-breadcrumbs',
  templateUrl: './survey-breadcrumbs.component.html',
  styleUrls: ['./survey-breadcrumbs.component.scss'],
  animations: [breadcrumbsAnimation]
})
export class SurveyBreadcrumbsComponent {
  @Input() language: string = 'EN';
  @Input() showBackIcon: boolean = true;
  routes: InnerRoute[] = []
  @Input('routes') set setRoutes(value: InnerRoute[]) { this.routes = value; }
}
